<script setup>
import { ref, onMounted, onUnmounted, watch, shallowRef } from 'vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

const props = defineProps({
  data: {
    type: Object,
    required: false,
    default: () => ({
      labels: ['8:00 AM', '9:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '4:00 PM'],
      datasets: [
        {
          label: 'Conversations',
          data: [6, 4, 6, 4, 1, 1],
          backgroundColor: '#4285F4',
          borderRadius: 4,
          barThickness: 20
        }
      ]
    })
  }
})

const chartCanvas = ref(null)
const chartInstance = shallowRef(null)

const renderChart = () => {
    if (chartInstance.value) {
        chartInstance.value.destroy()
        chartInstance.value = null
    }

    if (chartCanvas.value) {
        chartInstance.value = new Chart(chartCanvas.value, {
            type: 'bar',
            data: props.data,
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        display: false,
                        grid: {
                            display: false
                        }
                    },
                    y: {
                        grid: {
                            display: false
                        },
                         ticks: {
                             color: '#6b7280',
                             font: {
                                 size: 13
                             }
                         },
                         border: {
                             display: false
                         }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                         backgroundColor: '#1f2937',
                        padding: 10,
                        cornerRadius: 4,
                        displayColors: false
                    }
                }
            }
        })
    }
}

watch(() => props.data, () => {
    renderChart()
}, { deep: true })

onMounted(() => {
    renderChart()
})

onUnmounted(() => {
    if (chartInstance.value) {
        chartInstance.value.destroy()
        chartInstance.value = null
    }
})
</script>

<template>
  <div class="chart-wrapper">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<style scoped>
.chart-wrapper {
  height: 100%;
  width: 100%;
  min-height: 250px;
}
</style>
